import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { PopoverController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { LoginPageRoutingModule } from './login-routing.module';

import { LoginPage } from './login.page';
import { MasterFooterModule } from '../master/master-footer/master-footer.module';
import { HelpContentComponent } from './help-content/help-content.component';
import { TermsPage } from './terms/terms.page';
import { BeforeLoginNotificationsPage } from './before-login-notifications/before-login-notifications.page';
import { AfterLoginNotificationsPage } from './after-login-notifications/after-login-notifications.page';
import { LanguageSwitcherModule } from '../components/language-switcher/language-switcher.module';
import { CustomInputModule } from '../master/common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    LoginPageRoutingModule,
    MasterFooterModule,
    TranslateModule,
    LanguageSwitcherModule,
    CustomInputModule
  ],
  declarations: [LoginPage, HelpContentComponent, TermsPage, BeforeLoginNotificationsPage, AfterLoginNotificationsPage],
})
export class LoginPageModule {}
